var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8077)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8077",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6394 21.7702C14.5087 29.3365 20.6635 35.4913 28.2298 39.3606L34.1021 33.4883C34.4513 33.1386 34.8912 32.8934 35.3722 32.7802C35.8533 32.667 36.3563 32.6904 36.8248 32.8477C39.9002 33.8581 43.117 34.3718 46.3541 34.3691C47.0614 34.3712 47.7391 34.6531 48.2393 35.1532C48.7394 35.6533 49.0214 36.3311 49.0234 37.0384V46.3541C49.0214 47.0614 48.7395 47.7391 48.2394 48.2393C47.7392 48.7394 47.0615 49.0214 46.3542 49.0234C21.2897 49.0234 0.976562 28.7103 0.976562 3.6458C0.978649 2.93852 1.26054 2.2608 1.76067 1.76067C2.2608 1.26054 2.93852 0.978649 3.6458 0.976562H12.9883C13.6956 0.978649 14.3733 1.26054 14.8734 1.76067C15.3735 2.2608 15.6554 2.93852 15.6575 3.6458C15.6528 6.88308 16.1664 10.1002 17.179 13.1751C17.3301 13.6463 17.3477 14.1501 17.2299 14.6307C17.1122 15.1113 16.8636 15.5498 16.5117 15.8978L10.6394 21.7702Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.ef889f945fa44c3805eb7b476f3d004c.svg";
export { ForwardRef as ReactComponent };